import React, { Component, Fragment } from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Document, Page } from 'react-pdf';
import { isImg, isDoc } from '../../../utils/attachments';
import unrecognizedDocsStyles from './docs.module.css';
import styles from '../../../custom/style.module.css';
import { FlexDiv, StyledCard, StyledCardTitle, } from '../../../custom/components';
import environment from '../../../custom/environments';
import { IconButton, Stack, Typography } from '@mui/material';
import ZoomIn from '../../../assets/images/actionIcons/zoomIn.svg';
import ZoomOut from '../../../assets/images/actionIcons/zoomOut.svg';
import { grey } from '@mui/material/colors';
import Slider from 'react-slick';
import { ArrowLeft, ArrowRight } from '@mui/icons-material';

class ViewDocuments extends Component {

  constructor(props) {
    super(props);
    this.state = {
      numPages: {},
      scale: 1.0,
      isDragging: false,
      startX: 0,
      startY: 0,
      scrollLeft: 0,
      scrollTop: 0,
      currentPage: 1,
    };
    this.pdfContainerRefs = {};
  }


  openLink = (link) => {
    window.open(link);
  };

  onDocumentLoadSuccess = (num, index) => {
    const numPages = this.state.numPages;
    numPages[`pdf_${index}`] = num._pdfInfo.numPages;
    this.setState({ numPages });
    if (this.handlePageChange) {
      this.handlePageChange(1);
    }
  };

  onDocumentLoadError = (error) => {
    console.log('🚀 ~ file: DocViewer.js:87 ~ ViewDocuments ~ error:', error);
  };

  handlePageChange = (newPage) => {
    this.setState({ currentPage: newPage });
  };

  // Scroll document on drag
  getPdfContainerRef = (index) => {
    if (!this.pdfContainerRefs[index]) {
      this.pdfContainerRefs[index] = React.createRef();
    }
    return this.pdfContainerRefs[index];
  };

  zoomIn = () => {
    this.setState((prevState) => ({ scale: prevState.scale + 0.2 }));
  };

  zoomOut = () => {
    this.setState((prevState) => ({ scale: Math.max(0.5, prevState.scale - 0.2) }));
  };

  handleMouseDown = (e, index) => {
    const container = this.getPdfContainerRef(index).current;
    if (!container) return;

    this.setState({
      isDragging: true,
      startX: e.pageX - container.offsetLeft,
      startY: e.pageY - container.offsetTop,
      scrollLeft: container.scrollLeft,
      scrollTop: container.scrollTop,
    });

    container.style.cursor = 'grabbing';
  };

  handleMouseMove = (e, index) => {
    if (!this.state.isDragging) return;

    const container = this.getPdfContainerRef(index).current;
    if (!container) return;

    e.preventDefault();
    const scale = this.state.scale || 1;
    const x = e.pageX - container.offsetLeft;
    const y = e.pageY - container.offsetTop;

    const walkX = ((x - this.state.startX) * 1.5) / scale;
    const walkY = ((y - this.state.startY) * 1.5) / scale;

    container.scrollLeft = this.state.scrollLeft - walkX;
    container.scrollTop = this.state.scrollTop - walkY;
  };

  handleMouseUp = (index) => {
    const container = this.getPdfContainerRef(index).current;
    if (container) container.style.cursor = 'grab';
    this.setState({ isDragging: false });
  };

  render() {
    const NextArrow = (props) => {
      const { onClick } = props;
      // Determine the last page for the current document
      const lastPage = this.state.numPages['pdf_0'] || 1;
      const isDisabled = this.state.currentPage >= lastPage;
      return (
        <IconButton
          aria-label='Next'
          onClick={onClick}
          className={unrecognizedDocsStyles.slideRightArrow}
          size='large'
          disabled={isDisabled}
          color='primary'
        >
          <ArrowRight sx={{ fontSize: 40 }} />
        </IconButton>
      );
    };

    const PrevArrow = (props) => {
      const { onClick } = props;
      const isDisabled = this.state.currentPage <= 1;
      return (
        <IconButton
          aria-label='Prev'
          onClick={onClick}
          className={unrecognizedDocsStyles.slideLeftArrow}
          size='large'
          disabled={isDisabled}
          color='primary'
        >
          <ArrowLeft sx={{ fontSize: 40 }} />
        </IconButton>
      );
    };
    const settings = {
      arrows: true,
      infinite: false,
      dots: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      swipe: false,
      draggable: false,
      beforeChange: (oldIndex, newIndex) => {
        this.handlePageChange(newIndex + 1);
      },
    };
    return (
      <StyledCard className={unrecognizedDocsStyles.h100} classes={{ paper: unrecognizedDocsStyles.h100 }}>
        <div className={unrecognizedDocsStyles.incomingDocHead}>
          <Stack direction='row' spacing={2} alignItems='center' justifyContent='space-between' mb={3}>
            <FlexDiv><StyledCardTitle>{this.props.title || 'Document Viewer'}</StyledCardTitle></FlexDiv>
            <Stack direction='row' spacing={2} mt={'-16px'}>
              <Typography variant='body2' color={'primary'}>
                {this.state.scale != 1 ? (Math.round(this.state.scale * 100) + '%') : ''}</Typography>
              <IconButton size='small' title='Zoom In' onClick={this.zoomIn} className={`${unrecognizedDocsStyles.docIcon} ${styles.p0}`}>
                <img src={ZoomIn} alt='zoom in' />
              </IconButton>
              <IconButton size='small' title='Zoom Out' onClick={this.zoomOut} className={`${unrecognizedDocsStyles.docIcon} ${styles.p0}`}>
                <img src={ZoomOut} alt='zoom out' />
              </IconButton>
            </Stack>
          </Stack>
        </div>
        <div className={`${unrecognizedDocsStyles.viewDocBody} ${styles.positionRelative}`}>
          {this.props.docData.length > 0 ?
            this.props.docData.map((item, i) => {
              const itemLink = environment.apiService + 'document?key=' + item.src;
              const fileName = item.src && item.src.split('/').pop();
              if (!item.src && item.request && !item.request_status) {
                return (
                  <Fragment key={i}>
                    <div className={unrecognizedDocsStyles.placeholderText}>
                      <div className={`${styles.fMiddle} ${styles.fColumn}`}>
                        <Typography component={'h5'} variant={'h5'} color='primary'>Document Requested</Typography>
                        <Typography component={'span'} variant={'caption'} color='text.secondary'>The document is yet to be received</Typography>
                      </div>
                    </div>
                  </Fragment>
                );
              }
              return (
                <div key={i}>
                  <div className={`${unrecognizedDocsStyles.canvasDoc} ${unrecognizedDocsStyles.px4} ${unrecognizedDocsStyles.pdfParentContainer}`}>

                    {item.src && isImg(fileName) && (
                      <img
                        src={itemLink}
                        alt={fileName}
                        className={unrecognizedDocsStyles.image}
                      />
                    )}

                    {item.src && isDoc(fileName) && (
                      <Slider {...settings}>
                        {Array.from(new Array(this.state.numPages[`pdf_${i}`]),
                          (el, index) => (
                            <div
                              key={`pdf_${index + 1}`}
                              className={unrecognizedDocsStyles.pdfContainer}
                              ref={this.getPdfContainerRef(index)}
                              onMouseDown={(e) => this.handleMouseDown(e, index)}
                              onMouseMove={(e) => this.handleMouseMove(e, index)}
                              onMouseUp={() => this.handleMouseUp(index)}
                              onMouseLeave={() => this.handleMouseUp(index)}
                              style={{
                                overflow: 'auto',
                                cursor: 'grab'
                              }}
                            >
                              <Document
                                key={`page_${index + 1}`}
                                file={itemLink}
                                onItemClick={() => {
                                  this.openLink(itemLink);
                                }}
                                options={{ withCredentials: true }}
                                onLoadSuccess={(page) => this.onDocumentLoadSuccess(page, i)}
                                onLoadError={this.onDocumentLoadError}
                              >
                                <Page
                                  className={unrecognizedDocsStyles.attachmentPage}
                                  pageNumber={index + 1}
                                  renderTextLayer={false}
                                  renderAnnotationLayer={false}
                                  width={500}
                                  scale={this.state.scale || 1.0}

                                />
                              </Document>
                            </div>
                          ))}
                      </Slider>
                    )}
                  </div>
                  <div className={unrecognizedDocsStyles.pagination}>
                    <Typography variant='caption' component={'p'} textAlign={'center'} color={grey[600]}>
                      {this.state.currentPage} / {this.state.numPages[`pdf_${i}`] || 0}
                    </Typography>
                  </div>
                </div>
              );
            }) :
            <div className={unrecognizedDocsStyles.placeholderText}>
              <div className={`${styles.fMiddle} ${styles.fColumn}`}>
                <Typography component={'h5'} variant={'h5'} color='primary'>Document Preview Window</Typography>
                <Typography component={'span'} variant={'caption'} color='text.secondary'>Please select a document to preview</Typography>
              </div>
            </div>}
        </div>
      </StyledCard>

    );
  }

}

export default (ViewDocuments);
